import AdminLayout from "../../../components/admin/layout/AdminLayout";
import CreateSurvey from "../../../components/common/survey/CreateSurvey";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";

function SurveyCreatePage() {
  const { userType } = useAuthStore();

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <CreateSurvey />
    </AdminLayout>
  );
}

export default SurveyCreatePage;
